import { Component, Input, booleanAttribute, computed, inject, input, signal } from '@angular/core';

import { RatingsDocumentTreeNode } from '../ratings-document-tree-node.model';
import { HorizonRatingsUtilsService } from '../../horizon-ratings-utils';

@Component({
    selector: 'topo-ratings-document-card',
    templateUrl: './ratings-document-card.component.html',
    styleUrls: ['./ratings-document-card.component.scss'],
    standalone: false
})
export class RatingsDocumentCardComponent {
  node = input<RatingsDocumentTreeNode>();
  @Input({ transform: booleanAttribute }) nested: boolean;

  private ratingsUtils = inject(HorizonRatingsUtilsService);

  ratingText = computed(() => {
    const { rating_number, custom_rating_number } = this.node().document;
    return this.ratingsUtils.getRatingsTextAndColor(custom_rating_number ?? rating_number)?.text;
  });

}
